import { atom } from 'nanostores';

/**
 * Whether the mobile sidebar drawer is open.
 *
 * Below the `lg` breakpoint the sidebar leaves the flex flow and becomes an
 * off-canvas drawer, so the button that opens it (the mobile top bar in
 * AppLayout) lives outside the Sidebar component. This atom is the link.
 * Above `lg` the sidebar is always in the layout and this value is ignored.
 */
export const $mobileSidebarOpen = atom<boolean>(false);

export function openMobileSidebar() {
  $mobileSidebarOpen.set(true);
}

export function closeMobileSidebar() {
  $mobileSidebarOpen.set(false);
}
